// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"1235955f","625":"3df9bd59","787":"f8498b66"}[chunkId] + ".chunk.js";
};